import '../../css/common.loadingSpinner.css';
import styling from '../core/styling.js';
import { getRequired, createDiv } from '../core/domMan';
export const wrapperName = 'spinnerWrapper';
export const identifier = 'spinner';

export default (ownerElem) => {
    let spinnerObj = document.getElementById(identifier);
    if (!spinnerObj) {
        ownerElem = ownerElem ?? getRequired(wrapperName);
        spinnerObj = createDiv(ownerElem, { id: identifier, classList : "pulse-spinner" });
    }

    const { animations } = styling;
    const fadeOut = styling.getAnimationCss(animations.fadeOut);

    return {
        hide: () => {
            spinnerObj.classList.add(fadeOut);
            setTimeout(() => spinnerObj.remove(), 500);
        }
    };
}